const sellingPlan = function () {
  const selectors = {
    sellingPlanSelect: '[js-selling-plan="plan-select"]',
    purchaseTypeRadio: '[js-selling-plan="radio"]',
    variantSelect: 'select.original-selector, .original_variant_id',
  };

  if (!document.querySelector(selectors.variantSelect)) {
    return;
  }


  document.addEventListener('DOMContentLoaded', handleSellingPlanChange);

  [...document.querySelectorAll(selectors.sellingPlanSelect)].forEach(select => {
    const parentForm = select.closest('form');
    if(!parentForm) return;
    parentForm.addEventListener('change', handleSellingPlanChange);
  })

  function handleSellingPlanChange(e) {
    let forms = [this];
    if (e.type == 'DOMContentLoaded') {
      forms = [...document.querySelectorAll('.product-card__form, .product-form')];
    }

    forms.forEach(form => {
      const variantId = form.querySelector(selectors.variantSelect)?.value;
      const planSelect = form.querySelector(selectors.sellingPlanSelect);
      const selectedPlan = form.querySelector(`${selectors.purchaseTypeRadio}:checked`);
      const checkElements = planSelect && selectedPlan && variantId;

      if (!checkElements) {
        return;
      }

      const interval = selectedPlan?.dataset?.interval;
      const intervalUnit = selectedPlan?.dataset?.intervalUnit;

      // Onetime buy
      if (!interval) {
        planSelect.options[0].selected = 'selected'
        return;
      }

      const name = `${interval} ${intervalUnit}`.toLocaleLowerCase();
      const optGroup = planSelect.querySelector(`[data-variant-id="${variantId}"]`)
      const option = optGroup?.querySelector(`[data-interval="${name}"]`) || planSelect?.querySelector(`[data-interval="${name}"]`)

      if (option) {
        option.selected = 'selected'
      }
    });
  }
}

sellingPlan();
